import { formatDate } from "./date/index.js";
import DateRefresher from "date-refresher";
import { TIMER } from "@/common/constants.js";

const endDate = formatDate(
  DateRefresher.updateByInterval(TIMER.date, TIMER.days, TIMER.time),
  "shortNumber",
);
// Куча title и subtitle'ов потому что сильно отличаются по дизайну два слайда
const SLIDES = [
	{
		text: `Только до ${endDate}`,
		title: "Дни продаж <b>Jaecoo</b> и <b>Jeland</b>!",
		subtitle2: "<span>Удвоили выгоду!</span> Успейте до повышения утильсбора!",
		subtitle:
			"Новый а/м <span>от <b>1 603 000 руб</b></span> + <span>Рассрочка</span>",
		subtitle_bottom: "Улучшим любое предложение конкурентов!",
		btn: "Зафиксировать условия по акции",
		img: "main.jpg",
		img_m: "main_m.jpg",
	},
];

export default SLIDES;
